/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { NewOrderProvider } from '@/context/NewOrderContext';
import React from 'react';
import UnprotectedOrder from './UnprotectedOrder';
function UnprotectedOrderWrapper() {
    return /*#__PURE__*/ _jsx(NewOrderProvider, {
        children: /*#__PURE__*/ _jsx(UnprotectedOrder, {})
    });
}
export default UnprotectedOrderWrapper;
